<script setup lang="ts">
import type { SearchShowsByFiltersRequest, Show } from 'streaming-availability'

type ShowCardGridProps = Pick<SearchShowsByFiltersRequest, 'showType'>

const { showType } = defineProps<ShowCardGridProps>()

const search = defineModel<string | undefined>('search')
const cursor = ref<string | undefined>(undefined)
const allShows = ref<Show[]>([])

const params = computed<Omit<SearchShowsByFiltersRequest, 'country'>>(() => ({
    showType,
    orderBy: search.value ? 'popularity_alltime' : 'popularity_1month',
    cursor: cursor.value,
    keyword: search.value,
}))

const { data, status } =
    await useStreamingAvailability().useAsyncSearchShows(params)

const nextCursor = computed(() => data.value?.nextCursor)
const shows = computed(() => data.value?.shows ?? [])
const isLoadingMore = computed(
    () => status.value === 'pending' && cursor.value !== undefined
)
const hasMore = computed(() => !!nextCursor.value)

watch(shows, (newShows) => {
    if (!newShows) return

    allShows.value.push(...newShows)
})

const loadMoreTrigger = useTemplateRef('loadMoreTrigger')

const loadMore = () => {
    if (!nextCursor.value || isLoadingMore.value) return

    console.info('trigger')
    console.info('cursor.value', cursor.value)
    console.info('next', nextCursor.value)
    cursor.value = nextCursor.value
}

watch(params, console.info)

const { stop } = useIntersectionObserver(
    loadMoreTrigger,
    ([intersectionObserverEntry]) => {
        if (!intersectionObserverEntry) return
        const { isIntersecting } = intersectionObserverEntry

        if (isIntersecting && hasMore.value && !isLoadingMore.value) {
            loadMore()
        }
    },
    { rootMargin: '50%' }
)

onUnmounted(stop)
</script>
<template>
    <!-- <UInput
        v-model="search"
        icon="i-lucide-search"
        size="md"
        variant="outline"
        placeholder="Search..."
        class="my-4 w-full md:w-1/2"
    /> -->
    <UPageGrid class="py-4">
        <ShowCard
            v-for="(show, index) in allShows"
            :key="show.id"
            :to-prefix="show.showType === 'movie' ? 'movies' : 'series'"
            v-bind="show"
            :index
        />
    </UPageGrid>
    <div
        v-if="hasMore"
        ref="loadMoreTrigger"
        class="flex justify-center py-8"
    />
    <div v-else-if="allShows.length > 0" class="py-8 text-center text-gray-800">
        No more shows to load
    </div>
</template>
